module.exports = __webpack_public_path__ + "media/lifesum-intro-dk-36308624.mp4";